<template>
  <BusinessProductsBlock
    v-if="isAuth && products?.length"
    ref="$productsBlock"
    :title="$t('components.business.products.productsWishlist.title')"
    :products="products"
    :show-more-text="$t('components.business.products.productsWishlist.toFavorites')"
    :show-more-link="`/profile/${account.id}/wishlist`"
    add-to-cart
    chapter="wishlist"
    @show-all="handleShowAll"
  />
</template>

<script setup lang="ts">
import { AnalyticsEvents } from '~/types/analytics';

const { isAuth, account } = useAccountStore();
const { products, getWishListProducts } = useWishlistStore();
const { $addEvent } = useNuxtApp();

const $productsBlock = ref();

const isVisible = useElementVisibility($productsBlock);

useLazyAsyncData(async () => {
  const result = isAuth.value ? await getWishListProducts() : undefined;

  return result;
});

function handleShowAll() {
  $addEvent(AnalyticsEvents.ShowAllClick, {
    chapter: 'wishlist',
  });
}

const unwatch = watch(() => isVisible.value, (value) => {
  if (value) {
    $addEvent(AnalyticsEvents.ProductsBlockView, {
      chapter: 'wishlist',
    });

    unwatch();
  }
}, { immediate: true });
</script>
